(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function scrollToNewsletter() {
      let target;
      try {
        target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      } catch {
        return;
      }
      if (!target || !target.querySelector('[data-newsletter-anchor]')) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
      });
    }
    if (document.readyState === 'complete') scrollToNewsletter();
    else window.addEventListener('load', scrollToNewsletter, { once: true });
    window.addEventListener('hashchange', scrollToNewsletter);
  })();

  } catch(e) { console.error(e); }
})();
})();
